import { render, staticRenderFns } from "./ArticleShareButton.vue?vue&type=template&id=f5576da0&"
import script from "./ArticleShareButton.vue?vue&type=script&lang=ts&"
export * from "./ArticleShareButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports